import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-xhr-backend";

// Import translations
import translationUA from './locales/ua/translation.json';
import translationRU from './locales/ru/translation.json';

// Initialize i18n
i18n
  .use(initReactI18next)
  .use(Backend) // used to load data from othe directory
  .use(LanguageDetector) // detects the current language
  .init({
    resources: {
      ua: {
        translation: translationUA,
      },
      ru: {
        translation: translationRU,
      },
    },
    fallbackLng: 'ua', // Fallback language
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
